import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-col ant-col-xs-12 ant-col-xl-1" }
const _hoisted_4 = { class: "ant-col ant-col-xs-12 ant-col-xl-11" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_13 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-23" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-1" }
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_19 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_20 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_23 = {
  class: "ant-col",
  style: {"flex":"0 0 250px","text-align":"left"}
}
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "acoes-item"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 4 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 6,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 7 }
const _hoisted_40 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_spin = _resolveComponent("spin")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_detalhe_rastreabilidade_modal = _resolveComponent("detalhe-rastreabilidade-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_form, {
        class: "ss-alinhar-texto-esquerda",
        layout: "vertical"
      }, {
        default: _withCtx(() => [
          (_ctx.state.indexSelecionado !== -1)
            ? (_openBlock(), _createBlock(_component_card, {
                key: 0,
                titulo: "PRODUTO A SER AJUSTADO",
                class: "ss-padding-separacao-esquerda ss-margin-inferior"
              }, {
                default: _withCtx(() => [
                  (_ctx.UtilitarioGeral.valorValido(_ctx.state.produtos[_ctx.state.indexSelecionado].identificador))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_a_form_item, {
                            label: "Produto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].descricaoProduto,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_a_form_item, {
                            label: "UN",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].unidade,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_a_form_item, {
                            label: "Estoque",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].descricaoEstoque,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_a_form_item, {
                            label: "Rastreabilidade",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].identificador,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_a_form_item, {
                            label: "Lote",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].numeroLote,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_a_form_item, {
                            label: "Fabricação",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].dataFabricacaoFormatada,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_form_item, {
                            label: "Vencimento",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].dataVencimentoFormatada,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_form_item, {
                            label: "Saldo",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.produtos[_ctx.state.indexSelecionado].quantidade,
                                ":quantidadeCasasDecimais": _ctx.state.produtos[_ctx.state.indexSelecionado].casasDecimais,
                                disabled: true
                              }, null, 8, ["valor", ":quantidadeCasasDecimais"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Qtd. Ajustada",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.qtdAjustada,
                                "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.qtdAjustada) = $event)),
                                quantidadeCasasDecimais: _ctx.state.produtos[_ctx.state.indexSelecionado].casasDecimais
                              }, null, 8, ["valor", "quantidadeCasasDecimais"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-primary",
                                title: "Alterar",
                                style: {"width":"100%"},
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmarAlteracao && _ctx.confirmarAlteracao(...args)))
                              }, "Alterar")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary",
                                title: "Cancelar",
                                style: {"width":"100%"},
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelarAlteracao && _ctx.cancelarAlteracao(...args)))
                              }, "Cancelar")
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_form_item, {
                            label: "Produto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].descricaoProduto,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_a_form_item, {
                            label: "UN",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].unidade,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_form_item, {
                            label: "Estoque",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.state.produtos[_ctx.state.indexSelecionado].descricaoEstoque,
                                disabled: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, {
                            label: "Saldo",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.produtos[_ctx.state.indexSelecionado].quantidade,
                                quantidadeCasasDecimais: _ctx.state.produtos[_ctx.state.indexSelecionado].casasDecimais,
                                disabled: true
                              }, null, 8, ["valor", "quantidadeCasasDecimais"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_a_form_item, {
                            label: "Qtd. Ajustada",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.qtdAjustada,
                                "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.qtdAjustada) = $event)),
                                quantidadeCasasDecimais: _ctx.state.produtos[_ctx.state.indexSelecionado].casasDecimais
                              }, null, 8, ["valor", "quantidadeCasasDecimais"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-primary",
                                title: "Alterar",
                                style: {"width":"100%"},
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirmarAlteracao && _ctx.confirmarAlteracao(...args)))
                              }, "Alterar")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary",
                                title: "Cancelar",
                                style: {"width":"100%"},
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelarAlteracao && _ctx.cancelarAlteracao(...args)))
                              }, "Cancelar")
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_card, { titulo: "FILTROS" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_busca_geral, {
                    empresas: [_ctx.props.empresa],
                    ordenacao: _ctx.gradeBase.ordenacaoSelecionada,
                    "onUpdate:ordenacao": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gradeBase.ordenacaoSelecionada) = $event)),
                    buscaRapida: _ctx.state.buscaRapida,
                    "onUpdate:buscaRapida": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                    buscaAvancada: _ctx.gradeBase.buscaAvancada,
                    "onUpdate:buscaAvancada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.gradeBase.buscaAvancada) = $event)),
                    onBuscarDados: _ctx.aplicarFiltros
                  }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_a_checkbox, {
                    style: {"margin-left":"8px"},
                    checked: _ctx.state.apenasComSaldo,
                    "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.apenasComSaldo) = $event)),
                    onChange: _ctx.buscarDados
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Apenas com saldo")
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"]),
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.state.apenasRastreabilidade,
                    "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.apenasRastreabilidade) = $event)),
                    onChange: _ctx.buscarDados
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Apenas com rastreabilidade")
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_card, {
            titulo: "DISPONIBILIDADE DOS PRODUTOS",
            class: "ss-padding-separacao-esquerda"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_spin, {
                    spinning: _ctx.telaBase.carregando
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        style: {"max-height":"calc(100vh - 220px)","min-height":"calc(100vh - 220px)","overflow":"auto"},
                        columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                        "data-source": _ctx.state.produtos,
                        rowKey: "codigo",
                        pagination: false,
                        loading: _ctx.gradeBase.buscandoDados,
                        size: "small"
                      }, {
                        bodyCell: _withCtx(({ column, text, index, record }) => [
                          (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.visualizarSelecionado(index))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(text), 1)
                              ], 8, _hoisted_26))
                            : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.props.modoAjuste)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("a", {
                                          class: "editar",
                                          onClick: ($event: any) => (_ctx.alterarQtdProduto(index))
                                        }, [
                                          _createVNode(_component_icone, { nome: "editar" })
                                        ], 8, _hoisted_28)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.UtilitarioGeral.valorValido(record.identificador))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("a", {
                                          class: "visualizar",
                                          onClick: ($event: any) => (_ctx.visualizarSelecionado(index))
                                        }, [
                                          _createVNode(_component_icone, { nome: "visualizar" })
                                        ], 8, _hoisted_30),
                                        _createElementVNode("a", {
                                          class: "imprimir",
                                          onClick: ($event: any) => (_ctx.imprimir(index))
                                        }, [
                                          _createVNode(_component_icone, { nome: "imprimir" })
                                        ], 8, _hoisted_31)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (column.key === 'Densidade')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    (_ctx.UtilitarioGeral.validaLista(record.controles) && record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.Densidade))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.Densidade)?.valor, 2) + ' ' + record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.Densidade)?.unidadeMedida), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (column.key === 'Ph')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      (_ctx.UtilitarioGeral.validaLista(record.controles) && record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.PH))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.PH)?.valor, 2) + ' ' + record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.PH)?.unidadeMedida), 1))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais, false, true)), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          (_ctx.UtilitarioData.aplicaFormatoData(text) !== '01/01/1901')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_36))
                                        ], 64))
                                      : (column.key === 'Rastreabilidade')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                            _createElementVNode("span", null, "Produto: " + _toDisplayString(record.codigoProduto + ' - ' + record.descricaoProduto), 1),
                                            _createElementVNode("span", null, "UN: " + _toDisplayString(record.unidade), 1),
                                            _createElementVNode("span", null, [
                                              _createTextVNode("Identificador: "),
                                              _createElementVNode("b", null, [
                                                _createElementVNode("a", {
                                                  onClick: ($event: any) => (_ctx.visualizarSelecionado(index))
                                                }, [
                                                  _createElementVNode("span", null, _toDisplayString(record.numero), 1)
                                                ], 8, _hoisted_38)
                                              ])
                                            ]),
                                            _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                            _createElementVNode("span", null, "Saldo: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, record.casasDecimais)), 1)
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(text), 1))
                        ]),
                        emptyText: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, {
                            resultadoPesquisa: !_ctx.telaBase.carregando,
                            mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
                          }, null, 8, ["resultadoPesquisa", "mensagem"])
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "loading"]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_a_pagination, {
                            class: "ss-paginacao-completa",
                            current: _ctx.state.paginacao.current,
                            "onUpdate:current": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.paginacao.current) = $event)),
                            size: "small",
                            total: _ctx.state.paginacaoApi.totalRegistros,
                            "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} registros`,
                            "page-size": _ctx.state.paginacao.pageSize,
                            pageSizeOptions: _ctx.state.paginacao.pageSizeOptions,
                            onShowSizeChange: _ctx.onShowSizeChange,
                            showSizeChanger: _ctx.state.paginacao.showSizeChanger,
                            onChange: _ctx.onPageChange,
                            locale: { items_per_page: ' por página' }
                          }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "showSizeChanger", "onChange"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["spinning"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"]),
    _createVNode(_component_detalhe_rastreabilidade_modal, {
      visivel: _ctx.state.exibirDetalhe,
      "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.exibirDetalhe) = $event)),
      empresas: [_ctx.props.empresa],
      rastreabilidade: _ctx.state.rastreabilidadeSelecionada
    }, null, 8, ["visivel", "empresas", "rastreabilidade"])
  ], 64))
}